import { Button } from "@chakra-ui/button";
import { LinkIcon } from "@chakra-ui/icons";
import { Flex, Heading, Link } from "@chakra-ui/layout";
import React from "react";

export interface FormSectionHeaderProps {
  id: string;
  label: string;
}

function FormSectionHeader({ id, label }: FormSectionHeaderProps) {
  const [isIconVisible, setIconVisible] = React.useState<boolean>(false);

  return (
    <Button
      tabIndex={-1}
      as={Link}
      href={`#${id}`}
      style={{ scrollMarginTop: "300px" }}
      color="inherit"
      _hover={{ color: "inherit", textDecoration: "underline" }}
      _active={{ boxShadow: "none" }}
      _focus={{ boxShadow: "none", textDecoration: "underline" }}
      variant="link"
      id={id}
      onMouseEnter={() => {
        setIconVisible(true);
      }}
      onMouseLeave={() => {
        setIconVisible(false);
      }}
    >
      <Flex alignItems="center">
        <Heading fontWeight="bold" fontSize="23px" as="h3">
          {label}
        </Heading>
        {isIconVisible && <LinkIcon boxSize={4} marginLeft="3" />}
      </Flex>
    </Button>
  );
}

export default FormSectionHeader;
